import React, { Component } from 'react'
import { Icon } from 'modules/theme';
import { SidebarList, ModalTrigger, Button } from 'modules/theme';
import PropTypes from 'prop-types';
import { AvtarImg, Body, DataWrapperClass, Header, ProfileDiv, SidebarBox, UserName, BodyDiv } from '../styles/main';
// import ContactListPrivateAddEdit from '../../../../screens/settings/ContactListPrivate/components/ContactListPrivateAddEdit';
import { modalType } from '../../../../../helpers/dotenv';
import { withRouter } from 'react-router';

export class ContactProfileTheme extends Component {

    constructor(props) {
        super(props);
        this.rejectList = ["_id", "phone_number", "publicInfo", "updateBy", "update_at"]
        this.state = {
            showHide: false,
            modalType: modalType,
            contactId: this.props.custInfo.objInfo ? this.props.custInfo.objInfo._id : '' || '',
            editData: null,
        }
        this.closeModal = this.closeModal.bind(this);
        this.openModals = this.openModals.bind(this);

    }
    componentWillReceiveProps(nextProps) {
        console.log('componentWillReceiveProps', nextProps);
        // this.setState(nextProps);
    }
    renderDetails(title, text) {
        return (
            <BodyDiv className={"col-md-12"}>
                <span className='title'>{title}</span>
                <div className={text == "Not available" ? "text-secondary" : "text"}>{text}</div>
            </BodyDiv>
        )
    }

    // refreshPage() {
    //     setTimeout(()=>{
    //         window.location.reload(false);
    //     }, 10);
    //     console.log('page to reload')
    // }


    closeModal(isUpdated) {
        console.log('isUpdated', isUpdated);
        this.setState({ showHide: false });
        if (isUpdated && this.props.custInfo.objInfo ? this.props.custInfo.objInfo._id : '' || '') {
            setTimeout(() => {
                this.props.getList(
                    this.props.custInfo.info ? this.props.custInfo.info.phone_number : '',
                    this.props.custInfo.objInfo ? this.props.custInfo.objInfo._id : '' || ''
                );
            }, 3000)
        }
    }
    openModals(data) {
        console.log('aaaa', data);
        if (data) {
            this.setState({ showHide: true, editData: data });
        } else {
            this.setState({ showHide: true });
        }
    }

    renderActionBar(data) {
        console.log('dataaaa', data);
        const importTrigger = (
            <span className='active-sign'>
                {console.log('this.props.listData', this.props.listData)}
                <Button btnStyle="link" size="small" icon="edit" onClick={() => this.openModals(data)}>
                    {/* <MdOutlineAdd /> */}
                    {/* <img src='/images/plus.png' style={{ width: '12px' }} /> */}
                </Button>
            </span>
        );
        console.log('editDataaa', this.state.editData);
        console.log('constactId', this.state.contactId);

        return (
            <ModalTrigger
                title={this.moduleName}
                trigger={importTrigger}
                size="md"
                showHide={this.state.showHide}
                closeModal={this.closeModal}
                openModal={this.openModals}
                dialogClassName={this.state.modalType}
            >
                {/* <ContactListPrivateAddEdit
                    size="small"
                    isEdit={false}
                    editData={this.state.editData}
                    // CountryList={this.state.CountryList}
                    modalType={this.state.modalType}
                    closeModal={this.closeModal}
                    contactId={this.props.custInfo.objInfo ? this.props.custInfo.objInfo._id : '' || ''}
                    listField={this.props.custInfo.objInfo ? this.props.custInfo.objInfo.fields : ''}
                /> */}
            </ModalTrigger>
        )
    }
    render() {
        const { __ } = this.context;
        let _this = this;
        return (
            <DataWrapperClass>
                <ProfileDiv>
                    <AvtarImg>
                        <img src="/images/LoginAgent.png" />

                    </AvtarImg>
                    <UserName>
                        {/* {this.props.listData.map(data => {
                               console.log('data',data);
                            data.objInfo.name
                           })} */}
                        {this.props.custInfo.info ? this.props.custInfo.info.name : 'No Name'}
                        <div>{this.props.custInfo.info ? this.props.custInfo.info.phone_number : ''}</div>
                    </UserName>
                    {/* <span className='active-sign'><Icon icon="edit"></Icon></span> */}
                    {this.renderActionBar(this.props.custInfo.info)}

                </ProfileDiv>
                <hr style={{ borderTop: '0.7px dashed #303030', margin: '0px 20px 0px 20px', opacity: '0.2' }} />
                <SidebarList>
                    <SidebarBox style={{ height: 'calc(100vh - 218px)', margin: '0px', padding: '20px', borderRadius: '0px 0px 0px 10px' }}>
                        <Header>
                            Personal Infomation
                        </Header>
                        <div className={"row"} style={{ height: 'calc(100vh - 300px)', overflow: 'auto' }}>
                            {
                                this.props.listField && this.props.custInfo.info && this.props.listField.map((key) => {
                                    let value = this.props.custInfo.info[key] || "Not available";
                                    return (_this.renderDetails(
                                        key,
                                        value
                                    ))
                                })
                            }
                        </div>
                    </SidebarBox>
                </SidebarList>
            </DataWrapperClass>
        )
    }
}

ContactProfileTheme.contextTypes = {
    __: PropTypes.func
};

export default withRouter(ContactProfileTheme)


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ContactProfileTheme.js